import { z } from 'zod';

import { passwordCriteria } from './PasswordValidation.constants';
import { messages } from './PasswordValidation.messages';

export const passwordSchema = z.string().refine((value) => passwordCriteria.every((criteria) => criteria.test(value)), {
    message: messages.invalidPassword,
});
